export const TEMPLATE_FORM_CONSTANTS = {
  TITLES: {
    CREATE: 'Create New Email Template',
    EDIT: 'Edit Email Template',
  },
  LABELS: {
    TEMPLATE_NAME: 'Template Name',
    TEMPLATE_TYPE: 'Template Type',
    EMAIL_SUBJECT: 'Email Subject',
    DESCRIPTION: 'Description',
    FROM_EMAIL: 'From Email',
    FROM_NAME: 'From Name',
    REPLY_TO: 'Reply To',
    STATUS: 'Status',
    SET_AS_DEFAULT: 'Set as Default',
    ATTACHMENTS: 'Attachments (Optional)',
    EMAIL_CONTENT: 'Email Content',
    PLAIN_TEXT_CONTENT: 'Plain Text Content (Optional)',
    AVAILABLE_VARIABLES: 'Available Variables',
    LIVE_PREVIEW: 'Live Preview',
  },
  PLACEHOLDERS: {
    TEMPLATE_NAME: 'Enter template name',
    TEMPLATE_TYPE: 'Select template type',
    EMAIL_SUBJECT: 'Enter email subject',
    DESCRIPTION: 'Template description',
    FROM_EMAIL: 'sender@example.com',
    FROM_NAME: 'Sender Name',
    REPLY_TO: 'reply@example.com',
    HTML_CONTENT_VISUAL: 'Start creating your email template...',
    HTML_CONTENT_CODE: 'Enter HTML email content from the visual editor',
    HTML_CONTENT_RAW: 'Paste your complete HTML email template here...',
    PLAIN_TEXT: 'Enter plain text version (auto-generated if left empty)',
  },
  BUTTONS: {
    CANCEL: 'Cancel',
    CLEAR_FORM: 'Clear Form',
    SAVE: 'Save Template',
    UPDATE: 'Update',
    CREATE: 'Create',
    TEMPLATE: 'Template',
    TEST_VALIDATION: 'Test Validation',
    FORMAT_CODE: 'Format Code',
    CLEAR_ALL: 'Clear All',
    RESTORE_ORIGINAL: 'Restore Original',
    CTA_BUTTON: 'CTA Button',
    DIVIDER: 'Divider',
    SPACER: 'Spacer',
    SOCIAL_LINKS: 'Social Links',
    REMOVE: 'Remove',
  },
  MESSAGES: {
    REQUIRED_FIELDS: 'Required Fields',
    REQUIRED_FIELDS_DESC: 'Template Name, Template Type, Email Subject, From Email, and HTML Content are required fields.',
    EMAIL_CONFIGURATION: 'Email Configuration',
    EMAIL_CONFIGURATION_DESC: 'Configure the sender information for your email templates. The "From Email" field is required and must be a valid email address.',
    FROM_EMAIL_REQUIRED: 'Required: Must be a valid email address (e.g., sender@example.com)',
    INVALID_EMAIL: 'Please enter a valid email address',
    ATTACHMENTS_DESC: 'Add file attachments to your email template. Supported formats: PDF, DOC, DOCX, JPG, PNG, GIF',
    DRAG_FILES_HERE: 'Click to add attachments or drag files here',
    CURRENT_ATTACHMENTS: 'Currently {count} attachment(s) added',
    FILE_UPLOAD: 'File Upload',
    FILE_UPLOAD_DESC: 'File upload functionality will be implemented in a future update.',
    NO_CONTENT: '<p>No content available</p>',
    SUBJECT_PREFIX: 'Subject:',
    HTML_REQUIRED: 'HTML content is required. Use the templates below or create your own HTML email.',
    VISUAL_EDITOR_WARNING: 'Visual Editor may strip complex styling and HTML structure. Your original HTML will be preserved in Code/HTML modes. Continue?',
    HTML_RESTORE_PROMPT: 'Would you like to restore your original HTML template? This will replace any changes made in the Visual Editor.',
    HTML_MODE_WARNING: 'Visual Editor may have simplified your HTML. Switch to HTML mode to restore original formatting.',
    HTML_MODE_INFO: 'Perfect for complex email templates with custom styling. Visual Editor may strip advanced formatting when switching modes.',
    HTML_MODE_MOBILE_TIP: 'HTML mode gives you full control on small screens.',
    MOBILE_TIP: 'Tip: On mobile, use the HTML mode for better control over your email template.',
    QUICK_INSERT: 'Quick Insert',
    QUICK_INSERT_MOBILE: 'Quick Insert (Mobile)',
    QUICK_INSERT_DESKTOP: 'Quick Insert (Desktop)',
    EMAIL_TEMPLATES: 'Email Templates',
    EMAIL_TEMPLATES_MOBILE: 'Email Templates (Mobile)',
    EMAIL_TEMPLATES_DESKTOP: 'Email Templates (Desktop)',
    ACTIONS: 'Actions',
    ACTIONS_MOBILE: 'Actions (Mobile)',
    ACTIONS_DESKTOP: 'Actions (Desktop)',
    VISUAL_EDITOR: 'Visual Editor',
    RICH_TEXT_CODE: 'Rich Text Code',
    RAW_HTML_EDITOR: 'Raw HTML Editor',
    PASTE_COMPLETE_HTML: 'Paste complete HTML templates here',
    EMAIL_HEADERS_PREVIEW: 'Email Headers Preview',
    EMAIL_CONTENT_PREVIEW: 'Email Content Preview',
    FROM_PREFIX: 'From:',
    VALIDATION_PASSED: 'Validation Passed',
    VALIDATION_PASSED_DESC: 'All required fields are filled correctly!',
  },
  EDITOR_MODES: {
    VISUAL: 'visual',
    CODE: 'code',
    HTML: 'html',
  },
  DEFAULT_VALUES: {
    STATUS: 'DRAFT',
    FROM_EMAIL: 'elio@starntop.com',
    FROM_NAME: 'Elio & Papas',
  },
  TEMPLATES: {
    HEADER: 'header',
    FOOTER: 'footer',
    TWO_COLUMN: 'twoColumn',
    IMAGE_TEXT: 'imageText',
  },
};
